import {
  initAmplitude,
  sendAmplitudeData,
  setAmplitudeUserId,
  setAmplitudeUserProperties,
  setAmplitudeVersion,
} from './amplitude';
import { initSentry, setSentryUser } from './sentry';

export const initAnalytics = () => {
  initSentry();
  initAmplitude();
  setAmplitudeVersion('1.3');
};

export const sendAnalyticsEvent = (event, properties) => {
  sendAmplitudeData(event, properties);
};

export const setAnalyticsUser = (user) => {
  setAmplitudeUserId(user['session-token']);
  setAmplitudeUserProperties(user.userData);
  setSentryUser(user);
};
